<script>
    import { PageStore } from '../stores/PageStore.svelte.js';

    const Component = $derived(PageStore.component);
</script>

<main class="relative z-10 flex-1 overflow-y-auto bg-gray-100 bg-white p-4" id="frontendMain">
    {#if Component}
        <Component />
    {/if}
</main>
